"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = void 0;
const chalk = require("chalk");
const debug_1 = require("../debug");
const dep_graph_1 = require("@snyk/dep-graph");
const display_1 = require("./display");
const error_1 = require("../utils/error");
async function display(scanResults, testResults, errors, options) {
    if (errors.length > 0) {
        error_1.exitWith(error_1.ExitCode.Error, display_1.displayErrors(errors).join('\n'));
    }
    const result = [];
    let hasDependencies = false;
    let hasVulnerabilities = false;
    try {
        if (options === null || options === void 0 ? void 0 : options.path) {
            const prefix = chalk.bold.white(`\nTesting ${options.path}...\n`);
            result.push(prefix);
        }
        if (options === null || options === void 0 ? void 0 : options.debug) {
            const signatureLines = display_1.displaySignatures(scanResults);
            result.push(...signatureLines);
        }
        for (const testResult of testResults) {
            const depGraph = dep_graph_1.createFromJSON(testResult.depGraphData);
            const [dependencySection, issuesSection] = display_1.selectDisplayStrategy(options, depGraph, testResult);
            if (testResult.depGraphData.pkgs.length > 1) {
                hasDependencies = true;
            }
            if (testResult.issues.length > 0) {
                hasVulnerabilities = true;
            }
            result.push(...dependencySection, ...issuesSection);
        }
    }
    catch (error) {
        debug_1.debug(error.message || `Error displaying the results: ${error}`);
        error_1.exitWith(error_1.ExitCode.Error, 'Error displaying results.');
    }
    if (hasVulnerabilities) {
        error_1.exitWith(error_1.ExitCode.VulnerabilitiesFound, result.join('\n'), testResults);
    }
    if (!hasDependencies) {
        result.push(`Could not detect supported target files in ${options === null || options === void 0 ? void 0 : options.path}`);
        error_1.exitWith(error_1.ExitCode.NoSupportedFiles, result.join('\n'));
    }
    return result.join('\n');
}
exports.display = display;
//# sourceMappingURL=index.js.map